import React from 'react';
import PropTypes from 'prop-types';
import ProgressSpinner from '../../material/ProgressSpinner';
import PagedView from './PagedView';
import { formatClassName } from '../../Util';

/** renders data in card format within the PagedView component
 *  the child compondent will be cloned with the data row passed in as
 *  additional props
 *  ALL PROPS ARE PASSED TO PAGED_VIEW -> PAGE
 *  (see PagedView and Page documentation) */
export default class CardsView extends React.Component {
  static propTypes = {
    /** overrides the default behavior for activePage */
    activePage: PropTypes.number,
    /** adds additional className to each card's wrapper div */
    cardClass: PropTypes.string,
    /** children should be a single child component that will be cloned for
     *  each data row */
    children: PropTypes.element.isRequired,
    /** array of data that will be rendered as cards for each row */
    data: PropTypes.array.isRequired,
    /** set to true when you want to display a loading icon */
    isLoadingData: PropTypes.bool,
    /** specifies what row attribute is used as the key for each
     *  rendered card */
    keyField: PropTypes.string,
    /** this method will be called to fetch data for the page
     * called with (activePage) */
    loadAction: PropTypes.func,
    /** callback(activePage) when page is changed */
    onPageChange: PropTypes.func,
    /** renders element at the end of the cards list
     * inside of the card wrapper */
    postCards: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.arrayOf(PropTypes.element)
    ]),
    /** renders element at the start of the cards list
     * inside of the card wrapper */
    preCards: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.arrayOf(PropTypes.element)
    ]),
    /** adds additional className to the wrapper around all of the cards */
    wrapperClass: PropTypes.string
  }

  static defaultProps = {
    keyField: 'id',
    onPageChange: () => {}
  }

  constructor(props) {
    super(props);

    const { activePage } = props;

    this.state = {
      activePage
    };
  }

  componentWillReceiveProps(newProps) {
    const { activePage } = newProps;

    if(!!activePage && activePage !== this.state.activePage) {
      this.setState({ activePage });
    }
  }

  onPageChange = (activePage) => {
    this.setState({ activePage }, () => {
      this.props.onPageChange(activePage);
    });
  }

  loadData = () => {
    this.props.loadAction(this.state.activePage);
  }

  renderContent = () => {
    const { data, wrapperClass, isLoadingData,
      preCards, postCards } = this.props;
    const wrapperClassName = formatClassName([
      'card-list-wrapper',
      wrapperClass,
      isLoadingData && 'card-data-loading'
    ]);

    return <div className={wrapperClassName}>
      {preCards}
      {data.map(item => this.renderCard(item))}
      {postCards}
      {isLoadingData && <ProgressSpinner containerClassName="everfi-card-loader" />}
    </div>
  }

  renderCard = (item) => {
    const { cardClass, children, keyField } = this.props;
    if (!children || !item) {
      return null;
    }
    const cardClassName = formatClassName(['card', cardClass]);
    return (
      <div className={cardClassName} key={item[keyField]}>
        {React.cloneElement(React.Children.only(children), item)}
      </div>
    );
  }

  render() {
    return (
      <PagedView
        contentType="cards"
        inPanel={false}
        {...this.props}
        loadData={this.loadData}>
        {this.renderContent()}
      </PagedView>
    );
  }
}
